import { getAuth } from "./authService";
import { ENDPOINTS } from "./apiEndponts";

export const postSales = async (saleData) => {
  try {
    const auth = getAuth();
    const token = auth?.token;

    console.log("POST /sales-orders body:", saleData);
    console.log("POST /sales-orders headers:", {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });

    const response = await fetch(ENDPOINTS.SALE_ORDER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(saleData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al crear la venta:", error);
    throw error;
  }
};

export const postPurchase = async (purchaseData) => {
  try {
    const auth = getAuth();
    const token = auth?.token;

    const response = await fetch(ENDPOINTS.PURCHASE_ORDER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(purchaseData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al crear la compra:", error);
    throw error;
  }
};

export const getOrders = async () => {
  try {
    const auth = getAuth();
    const token = auth?.token;

    const response = await fetch(ENDPOINTS.GET_ORDERS, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error al obtener las ordenes:", error);
    throw error;
  }
};

// Obtener ventas (GET)
export const getSales = async () => {
  try {
    const auth = getAuth();
    const token = auth?.token;

    const response = await fetch(ENDPOINTS.SALE_ORDER, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error al obtener las ventas:", error);
    throw error;
  }
};

// Obtener compras (GET)
export const getPurchases = async () => {
  try {
    const auth = getAuth();
    const token = auth?.token;

    const response = await fetch(ENDPOINTS.PURCHASE_ORDER, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error al obtener las compras:", error);
    throw error;
  }
};